import classNames from 'classnames/bind';
import React, { useLayoutEffect } from 'react';
import { useInView } from 'react-intersection-observer';

import { BREAKPOINT_SM } from 'constants/breakpoints';
import useWindowWidth from 'hooks/use-window-width';

import styles from './hero.module.scss';
import Slider from './slider';

const cx = classNames.bind(styles);

const Hero = () => {
  const [sectionRef, inView] = useInView({});
  const windowWidth = useWindowWidth();

  useLayoutEffect(() => {
    if (windowWidth <= BREAKPOINT_SM) {
      if (sectionRef.current) {
        // set section height on mobile screens to viewport height (minus ticker height)
        sectionRef.current.style.height = `${window.innerHeight - 50}px`;
      }
    }
  }, [windowWidth, sectionRef]);

  return (
    <section className={cx('section')} ref={sectionRef}>
      {inView && <Slider />}
    </section>
  );
};

export default Hero;
